import React from 'react'
import { graphql } from 'gatsby'
import {
  Layout,
  Wrapper,
  BannerContainer,
  Billboard,
  Row,
  Column,
  BannerWrapper,
  Title,
  GreySection,
  DarkSection,
  H4,
  H3,
  Prompt,
  SEO,
} from '../components'
import * as Icons from '../components/icons'
import Android from '../images/paas/android.png'
import H5 from '../images/paas/h5.png'
import IOS from '../images/paas/ios.png'
import MacOS from '../images/paas/macos.png'
import MP from '../images/paas/mp.png'
import TV from '../images/paas/tv.png'
import Windows from '../images/paas/windows.png'
import ARM from '../images/paas/arm.png'
import X86 from '../images/paas/x86.png'
import ArrowImg from '../images/iaas/arrow.png'
import { Arrow } from '../molecules/iaas/atoms'
import AdaptationSection from '../molecules/paas/mobileAdaptaion.jsx'

function Paas(props) {
  const { data } = props
  return (
    <Layout>
      <SEO
        title='Pass解决方案，云游戏Pass解决方案-斗龙云游戏'
        description='斗龙云游戏Paas解决方案，强大的实时串流系统，一站式云游戏PaaS方案，助力云游戏业务快速成长。'
        keywords='Pass解决方案,云游戏解决方案,云游戏Pass解决方案,斗龙云'
      />
      <AdaptationSection>
        <BannerContainer height={980} mobileHeight={360}>
          <BannerWrapper $fromPaas mobileHeight={350} PCHeight={659}>
            <h1>
              斗龙云游戏
              <br />
              Paas解决方案
            </h1>
            <p>
              强大的实时串流系统 · 一站式云游戏PaaS方案
              <br />
              助力云游戏业务快速成长
            </p>
          </BannerWrapper>
          <GreySection
            $fromPaas
            mobilePadding={'20px 0'}
            PCPadding={'83px 0'}
            style={{ width: '100%' }}
          >
            <Wrapper>
              <Row style={{ textAlign: 'center' }}>
                <Column xs='6' lg='1.7'>
                  <img style={{ margin: '20px 0' }} src={IOS} alt='' />
                  <H4>IOS</H4>
                </Column>
                <Column xs='6' lg='1.7'>
                  <img style={{ margin: '20px 0' }} src={Android} alt='' />
                  <H4>Android</H4>
                </Column>
                <Column xs='6' lg='1.7'>
                  <img style={{ margin: '20px 0' }} src={H5} alt='' />
                  <H4>H5</H4>
                </Column>
                <Column xs='6' lg='1.7'>
                  <img style={{ margin: '20px 0' }} src={Windows} alt='' />
                  <H4>Windows</H4>
                </Column>
                <Column xs='6' lg='1.7'>
                  <img style={{ margin: '20px 0' }} src={MacOS} alt='' />
                  <H4>Macos</H4>
                </Column>
                <Column xs='6' lg='1.7'>
                  <img style={{ margin: '20px 0' }} src={TV} alt='' />
                  <H4>TV</H4>
                </Column>
                <Column xs='6' lg='1.7'>
                  <img style={{ margin: '20px 0' }} src={MP} alt='' />
                  <H4>小程序</H4>
                </Column>
              </Row>
            </Wrapper>
          </GreySection>
          <Billboard fluid={data.banner.childImageSharp.fluid} />
        </BannerContainer>
      </AdaptationSection>
      <DarkSection>
        <Wrapper>
          <Title>方案优势</Title>
          <Row spacing={3}>
            <Column xs='4' lg='1.5'>
              <Icons.Paas1 style={{ fontSize: 60, margin: 20 }} />
            </Column>
            <Column xs='8' lg='4.5'>
              <H3>行业领先的核心技术</H3>
              <Prompt>
                • 与芯片厂商深度研发合作
                <br />
                • 小于10ms超低时延的串流技术
                <br />• 1080P/4K/8K支持60FPS/120FPS
              </Prompt>
            </Column>
            <Column xs='4' lg='1.5'>
              <Icons.Paas2 style={{ fontSize: 60, margin: 20 }} />
            </Column>
            <Column xs='8' lg='4.5'>
              <H3>完善成熟的Paas平台</H3>
              <Prompt>
                • 提供全端SDK，快速部署
                <br />
                • 智能资源管理和监控
                <br />• 按需定制服务
              </Prompt>
            </Column>
            <Column xs='4' lg='1.5'>
              <Icons.Paas3 style={{ fontSize: 60, margin: 20 }} />
            </Column>
            <Column xs='8' lg='4.5'>
              <H3>超强的平台兼容性</H3>
              <Prompt>
                • 适配各类终端，轻松跨平台
                <br />
                • 兼容x86/ARM架构
                <br />• 独创的容器/虚拟化技术
              </Prompt>
            </Column>
            <Column xs='4' lg='1.5'>
              <Icons.Paas4 style={{ fontSize: 60, margin: 20 }} />
            </Column>
            <Column xs='8' lg='4.5'>
              <H3>高安全性的基础资源</H3>
              <Prompt>
                • 数据云端化，保障用户数据安全
                <br />
                • 网络物理隔离，系统安全加固
                <br />• DDoS 防护
              </Prompt>
            </Column>
          </Row>
        </Wrapper>
      </DarkSection>
      <GreySection>
        <Wrapper>
          <Title>方案架构</Title>
          <Row style={{ textAlign: 'center' }}>
            <Column xs='12' lg='6'>
              <img src={X86} alt='' style={{ maxWidth: '100%' }} />
              <H3>X86</H3>
            </Column>
            <Column xs='12' lg='6'>
              <img src={ARM} alt='' style={{ maxWidth: '100%' }} />
              <H3>ARM</H3>
            </Column>
          </Row>
        </Wrapper>
      </GreySection>
      <DarkSection>
        <Wrapper>
          <Title>业务流程</Title>
          <Row style={{ textAlign: 'center' }}>
            <Column xs='6' lg='1'>
              <Icons.Iaas9 style={{ fontSize: 60 }} />
              <H4>申请合作</H4>
            </Column>
            <Column xs='0' lg='1.6'>
              <Arrow src={ArrowImg} alt='' />
            </Column>
            <Column xs='6' lg='1'>
              <Icons.Iaas10 style={{ fontSize: 60 }} />
              <H4>测试体验</H4>
            </Column>
            <Column xs='0' lg='1.6'>
              <Arrow src={ArrowImg} alt='' />
            </Column>
            <Column xs='6' lg='1'>
              <Icons.Paas7 style={{ fontSize: 60 }} />
              <H4>SDK集成</H4>
            </Column>
            <Column xs='0' lg='1.6'>
              <Arrow src={ArrowImg} alt='' />
            </Column>
            <Column xs='6' lg='1'>
              <Icons.Iaas11 style={{ fontSize: 60 }} />
              <H4>节点预定</H4>
            </Column>
            <Column xs='0' lg='1.6'>
              <Arrow src={ArrowImg} alt='' />
            </Column>
            <Column xs='6' lg='1'>
              <Icons.Paas9 style={{ fontSize: 60 }} />
              <H4>部署上线</H4>
            </Column>
          </Row>
        </Wrapper>
      </DarkSection>
    </Layout>
  )
}

export default Paas
export const query = graphql`
  query {
    banner: file(relativePath: { regex: "/paas/banner.png/" }) {
      ...fluidImage
    }
  }
`
